import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { calculatorSchema } from './calculatorSchema';
import {
  EXERCISE_PERIOD,
  GST_PERCENT,
  LEGAL_FEE,
  SERVICE_COMMISSION_PERCENT,
  TEMPORARY_EXTENSION_OF_STAY,
  OPTION_FEE,
  OPTION_EXERCISE_FEE,
  SUBMIT_RESALE_APPLICATION,
  ACCEPTANCE_RESALE_APPLICATION,
} from '@/constants/hdb-resale/sales-proceeds';
import { PAGE, YES_NO } from '@/constants/common';

export type FormTypes = z.infer<typeof calculatorSchema>;

export const initialState = {
  formField: {
    sellingPrice: 0,
    outstandingLoan: 0,
    optionFee: OPTION_FEE.DEFAULT,
    optionExerciseFee: OPTION_EXERCISE_FEE.DEFAULT,
    legalFees: LEGAL_FEE.DEFAULT,
    serviceCommissionPercent: SERVICE_COMMISSION_PERCENT,
    gstPercent: GST_PERCENT,
    others: 0,
    otpDate: new Date().toString(),
    exercisePeriod: EXERCISE_PERIOD.DEFAULT,
    submitResaleApplication: SUBMIT_RESALE_APPLICATION.DEFAULT,
    acceptanceResaleApplication: ACCEPTANCE_RESALE_APPLICATION.DEFAULT,
    temporaryExtensionOfStay: TEMPORARY_EXTENSION_OF_STAY.DEFAULT,
    // Outstanding HDB Payments defaults
    hasResaleLevy: YES_NO.NO,
    resaleLevyPayable: 0,
    resaleLevyType: '',
    hasUpgradingCost: YES_NO.NO,
    upgradingCost: 0,
    // Associated Payments defaults
    resaleApplicationFee: '80',

    // Next Housing Plans defaults
    isPurchasingAnotherHDBFlat: YES_NO.NO,
    isSecondHDBLoan: YES_NO.NO,
    profiles: [
      {
        name: 'Profile A',
        cpfUsedForHousing: 0,
        cpfAccruedInterest: 0,
      },
      {
        name: 'Profile B',
        cpfUsedForHousing: 0,
        cpfAccruedInterest: 0,
      },
    ],

    // Summary defaults
    cashProceedsForNextHDB: 0,
    estimateCashProceeds: 0,
    serviceCommissionAmount: 0,
  },
  loading: true,
  from: '' as PAGE | '',
};

export const salesProceedsSlice = createSlice({
  name: 'salesProceeds',
  initialState,
  reducers: {
    updateDataForm: (
      state,
      action: PayloadAction<
        FormTypes & {
          from: PAGE | '';
        }
      >,
    ) => {
      const { from, ...rest } = action.payload;

      state.formField = rest;
      state.from = action.payload.from;
    },
    updateFrom: (state, action: PayloadAction<PAGE>) => {
      state.from = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: () => {},
});

export const { updateDataForm, updateFrom, reset } = salesProceedsSlice.actions;

export default salesProceedsSlice.reducer;
